import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { handleQuerySuccess } from '../../../../hooks/useQuriesSuccess';
import { apiRequest } from './../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import useDeleteMutation from '../../../../hooks/apis/useDeleteMutaion';
import useSaveMutation from '../../../../hooks/apis/useSaveMutaion';
import useSearchMutaion from '../../../../hooks/apis/useSearchMutaion';
import { mapParamsBySchema, mapRowsBySchema } from '../../../../util';
import { NOT_BASIC_01_02_Schema } from './NOT_BASIC_01_02_Schema';

/**
 * 공지사항 기본정보(NOT_BASIC_01_02) 관련 React Query 훅 모음
 * - 기본 조회(useQuery): useSearch1
 * - 파일 목록 조회(useSearchMutaion): useSearch2
 * - 저장(useMutation): useSave1 (공지사항 저장), useSave2 (파일 저장)
 * - 삭제(useMutation): useDelete1 (파일 삭제)
 *
 * 만약 MUTATION 훅에서 공통 응답 처리 외에 추가 성공 콜백이 필요하면
 * successOptions 파라미터로 onSuccess 콜백 함수를 넘겨줄 수 있다.
 */

// 회사 정보 조회 (Redux SearchInfo 기반 — 레거시)
export const useSearch1 = (options = {}) => {
  const { onSuccess } = options;
  const params = mapParamsBySchema(NOT_BASIC_01_02_Schema.mapper.search1);

  const query = useQuery({
    queryKey: ['utility', 'getCompanyInfo', params],
    queryFn: () =>
      apiRequest('post', Global.urls.Utility.getCompanyInfo, params),
    enabled: true, // 자동 실행 여부
  });

  useEffect(() => {
    if (!query.isSuccess) return;
    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

/** 사업장 목록 조회 — `run({ search: { coCd } })` 로 회사별 조회 */
export const useSearch1Run = (successOptions) => {
  return useSearchMutaion((context) => {
    const encryptedParams = mapParamsBySchema(
      NOT_BASIC_01_02_Schema.mapper.search1,
      context
    );
    return apiRequest(
      'post',
      Global.urls.Utility.getCompanyInfo,
      encryptedParams
    );
  }, successOptions);
};

// 파일 목록 조회
export const useSearch2 = (successOptions) => {
  return useSearchMutaion((context) => {
    const encryptedParams = mapParamsBySchema(
      NOT_BASIC_01_02_Schema.mapper.search2,
      context
    );
    return apiRequest(
      'post',
      Global.urls.Notice.getNotBasicR2,
      encryptedParams
    );
  }, successOptions);
};
// 부서조회
export const useSearch3 = (successOptions) => {
  return useSearchMutaion((context) => {
    const encryptedParams = mapParamsBySchema(
      NOT_BASIC_01_02_Schema.mapper.search3,
      context
    );
    return apiRequest(
      'post',
      Global.urls.Depart.getDepBasicR1,
      encryptedParams
    );
  }, successOptions);
};

// 파일 삭제
export const useDelete1 = (options = {}) => {
  return useDeleteMutation(async (rows) => {
    const payload = mapRowsBySchema(
      rows,
      NOT_BASIC_01_02_Schema.mapper.delete1
    );

    return apiRequest('post1', Global.urls.Notice.deleteNotBasicD1, payload);
  }, options);
};

// 공지사항 저장
export const useSave1 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, NOT_BASIC_01_02_Schema.mapper.save1);

    return apiRequest('post1', Global.urls.Notice.saveNotBasicU1, payload);
  }, options);
};

// 파일 저장
export const useSave2 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, NOT_BASIC_01_02_Schema.mapper.save2);

    return apiRequest('post1', Global.urls.Notice.saveNotBasicU2, payload);
  }, options);
};
